import { render } from "./Users.vue?vue&type=template&id=c52c25ba&scoped=true"
import script from "./Users.vue?vue&type=script&lang=ts"
export * from "./Users.vue?vue&type=script&lang=ts"

import "./Users.vue?vue&type=style&index=0&id=c52c25ba&lang=css"
import "./Users.vue?vue&type=style&index=1&id=c52c25ba&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c52c25ba"

export default script